import api from './index'
/**
 * 获取通话列表
 * @param {*} data
 * @returns
 */
export const getCallRecord = (data) => {
  return api({ url: '/admin/communication/log', data })
}
/**
 * 获取通话详情
 * @param {*} data
 * @returns
 */
export const getSessionDetail = (data) => {
  return api({ url: '/admin/communication/detail', method: 'post', data })
}

/**
 * 获取会话概要列表
 * @param {*} data
 * @returns
 */
export const getSummaryList = (data) => {
  return api({ url: '/admin/dialog/list', data })
}

/**
 * 获取会话详情列表
 * @param {*} data
 * @returns
 */
export const getDetailList = (data) => {
  return api({ url: '/admin/dialog/details/list', data })
}
/**
 * 删除会话详情
 * @param {*} data
 * @returns
 */
export const deleteDetail = (data) => {
  return api({ url: '/admin/dialog/details/del', method: 'post', data })
}
/**
 * 搜索意图
 * @param {*} data
 * @returns
 */
export const searchIntent = (data) => {
  return api({ url: '/admin/intent/search', data })
}
/**
 * 编辑详情
 * @param {*} data
 * @returns
 */
export const editDetail = (data) => {
  return api({ url: '/admin/dialog/details/redress', method: 'post', data })
}
/**
 * 获取未回复列表
 * @param {*} data
 * @returns
 */
export const getNoReplyList = (data) => {
  return api({ url: '/admin/notreplied/list', data })
}
/**
 * 获取统一回复
 * @param {*} data
 * @returns
 */
export const getCommonReply = (data) => {
  return api({ url: '/admin/common_answer/search', method: 'post', data })
}
/**
 * 增加回复
 * @param {*} data
 * @returns
 */
export const addReply = (data) => {
  return api({ url: '/admin/notreplied/reply', method: 'post', data })
}

/**
 * 读取录音
 * @param {*} data
 * @returns
 */
export const getCallAudio = (data) => {
  return api({ url: '/admin/common/download', method: 'post', data })
}
/**
 * 获取通话总时长
 * @param {*} data
 * @returns
 */
export const getCallTime = (data) => {
  return api({ url: '/admin/communication/call/time', data })
}

/**
 * 获取label列表
 * @param {*} data
 * @returns
 */
export const getLabelList = (data) => {
  return api({ url: '/admin/label/labelList', data })
}

/**
 * 新增或删除标签
 * @param {*} data
 * @returns
 */
export const addLabel = (data) => {
  return api({ url: '/admin/label/postLabel', method: 'post', data })
}

/**
 * 删除标签
 * @param {*} id
 * @returns
 */
export const deleteLabel = (id) => {
  return api({ url: `/admin/label/deleteLabel/${id}`, method: 'post' })
}
